import { MathJax } from "better-react-mathjax";
import { Link } from "react-router-dom";

const DialogList = ({ dialogs }) => {
  if (!Array.isArray(dialogs)) return null;
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "var(--gap-base)",
        marginBottom: "var(--padding-section-bottom)",
      }}
    >
      {dialogs?.map((dialog) => {
        return (
          <Link
            key={dialog.id}
            to={`problems/${dialog?.id}`}
            style={{ textDecoration: "none" }}
          >
            <MathJax inline dynamic>
              {dialog?.topic}
            </MathJax>
          </Link>
        );
      })}
    </div>
  );
};

export default DialogList;
